/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputFilterComponent} from './input-filter.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {PipesModule} from '../../pipes/pipes.module';
import {TooltipModule} from '../../tooltip/tooltip.module';
import {FilterFooterModule} from '../filter-footer/filter-footer.module';
import {InputModule} from '../../input/input.module';
import {InputTextComponent} from '../../input/input-text/input-text.component';

@NgModule({
    declarations: [InputFilterComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        TooltipModule,
        FilterFooterModule,
        InputModule
    ],
    exports: [InputFilterComponent, InputTextComponent]
})
export class InputFilterModule {
}
